import { render } from "./WaitingApprove.vue?vue&type=template&id=29ffa082&scoped=true&ts=true"
import script from "./WaitingApprove.vue?vue&type=script&lang=ts"
export * from "./WaitingApprove.vue?vue&type=script&lang=ts"

import "./WaitingApprove.vue?vue&type=style&index=0&id=29ffa082&lang=scss&scoped=true"
import "./WaitingApprove.vue?vue&type=style&index=1&id=29ffa082&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ffa082"]])

export default __exports__